import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "transactionStatus",
})
export class TransactionStatusPipe implements PipeTransform {
  transform(value: unknown, ...args: unknown[]): unknown {
    switch (value) {
      case 0:
        return "Pending";
      case 1:
        return "Cancelled";
      case 2:
        return "Declined";
      case 3:
        return "Completed";
      case 4:
        return "Error";
      case 5:
        return "Rejected";
      case 6:
        return "Pending 72hrs to accept";
      case 7:
        return "Refunded due to none acceptance within 72hrs";
      case 8:
        return "Expired";
      case 9:
        return "Refund";
      default:
        return "";
    }
  }
}
